import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import config from 'app/requests/Order/Order.requests'
import simpleApi from 'app/services/simpleApi'
import {
    CancellationInfo,
} from '../../../orders.types'

type RequestParams = {
    orderNumber: string,
    data: CancellationInfo,
}

const useCancelOrderRequest = (onSuccess: () => void)
    : UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessPostpone,
        onError,
    } = useHandleStatusRequest({
        id: 'OrderByNumberView',
        title: 'Order Cancellation',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            orderNumber,
            data,
        }: RequestParams) => {
            return simpleApi({
                ...config.cancelOrder({
                    orderNumber,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessPostpone,
        onError,
    })
}

export default useCancelOrderRequest
